module.exports = __webpack_public_path__ + "static/media/uzbekistan.b7afc571.jpg";